export const legend = [
  {
    title: "Category & Sub-Category",
    className: "bg-[#00ba94]",
  },
  {
    title: "Planned",
    className: "bg-[#E4E2D8]",
  },
  {
    title: "Actual",
    className: "bg-[#BCB48E]",
  },
  {
    title: "% Complete",
    className: "bg-primary",
  },
  // {
  //   title: "Actual(Beyond Plan)",
  //   className: "bg-[#D3B434]",
  // },
  // {
  //   title: "% Complete(Beyond Plan)",
  //   className: "bg-brown-300",
  // },
];

export const taskOption = [
  { label: "All Task", value: "all" },
  { label: "Draft", value: "draft" },
  { label: "Planned", value: "planned" },
  { label: "Completed", value: "completed" },
];

export const dependencyType: any = {
  FINISH_TO_START: 'e2s',
  FINISH_TO_FINISH: 'e2e',
  START_TO_FINISH: 's2s',
  START_TO_START: 's2s',
}
export const zoomLevels = ["hour", "day", "week", "month"] as const;
export type ZoomLevel = (typeof zoomLevels)[number];

export const task = {
  tasks: [
    {
      id: 1,
      start: new Date(2025, 11, 1),
      end: new Date(2025, 11, 20),
      text: "Category 1",
      progress: 30,
      parent: 0,
      type: "summary",
      open: true,
    },
    {
      id: 2,
      start: new Date(2025, 11, 1),
      end: new Date(2025, 11, 10),
      text: "Sub Category 1",
      parent: 1,
      type: "summary",
      open: true,
    },
    {
      id: 3,
      start: new Date(2025, 11, 1),
      end: new Date(2025, 11, 5),
      text: "Task 1",
      parent: 2,
      type: "task",
      planStart: new Date(2025, 11, 1),
      planEnd: new Date(2025, 11, 5),
      planDuration: 5,
      dependency: 2,
      actualDuration: 5,
      progress: 40,
    },
    {
      id: 4,
      start: new Date(2025, 11, 5),
      end: new Date(2025, 11, 10),
      text: "Task 2",
      parent: 2,
      type: "task",
      progress: 0,
    },
  ],
  links: [
    {
      id: 1,
      source: 3,
      target: 4,
      type: "e2s",
    },
  ],
}
